var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('o-do-server-action-button',_vm._b({attrs:{"filename":_vm.filename,"request":_vm.request,"form":_vm.form,"uri":_vm.uri,"do-save":_vm.doSave}},'o-do-server-action-button',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }